import React from 'react';
import HeaderWeb from './header-web';

function HeaderWebEndUser(props: Record<string, unknown>) {
  return (
    <div className="EndUserHeaderWebScope">
      <HeaderWeb {...props} />
    </div>
  );
}

export default React.memo(HeaderWebEndUser);
